import { render, staticRenderFns } from "./UiRadioCard.vue?vue&type=template&id=6f880a48&"
import script from "./UiRadioCard.vue?vue&type=script&lang=js&"
export * from "./UiRadioCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports